module.exports = __webpack_public_path__ + "img/DE05785.76732aa8.png";